<template>
    <div class="video-box">
        <div class="video-box-bg">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>高考资讯</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <template>
            <el-tabs class="school-detail-nav video-box-list" @tab-click="activeTagHandler" style="margin-top: -46px;">
                <el-tab-pane v-for="(item,index) in tabList" :key="index">
                    <span slot="label" @mouseenter="hoverMenuHandler(index)" @mouseleave="hoverMenuHandler(index)">
                        <span class="span-box">
                            <span>{{item.tag_name}}</span>
                            <span class="el-icon-arrow-down" v-if="index == '5' && !hoverMoreStatus"></span>
                            <span class="el-icon-arrow-up" v-if="index == '5' && hoverMoreStatus"></span>
                        </span>
                        <ul class="menu-tools-ul" v-if="index == '5' && hoverMoreStatus">
                            <li @click.stop="changeTypeHandler3(item.id)" v-for="(item,index) in typeMoreList" :key="index">{{item.tag_name}}</li>
                        </ul>
                    </span>
                    <el-row class="video-box-content">
                        <el-row v-if="videoStatus == '1'">
                            <el-col v-for="index1 in 16" :key="index1" :span="6">
                                <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="210" width="300">
                                <rect x="0" y="20" width="280" height="150" />
                                <rect x="0" y="185" width="200" height="25" />
                                </ContentLoader>
                            </el-col>
                        </el-row>
                        <div class="no-data-box" v-else-if="videoStatus == '2'">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p>暂无数据</p>
                        </div>
                        <el-row class="video-list" v-else-if="videoStatus == '3'">
                            <el-col :span="6" v-for="(item,index) in videoList" :key="index" @click.native="linkToDetail(item.id)">
                            <div class="class-box">
                                <div class="video-bg" :style="{backgroundImage:'url(' + item.video_pic + ')'}">
                                    <img src="../../assets/images/play.png" alt="播放视频">
                                </div>
                                <el-row>
                                    <el-col :span="2">
                                        <div class="video-free" v-if="item.video_type == 0">免费</div>
                                        <div class="video-free video-free-vip" v-else>会员</div>
                                    </el-col>
                                    <el-col :span="22">
                                        <p>{{item.video_title}}</p>
                                    </el-col>
                                </el-row>
                                <div class="video-count">{{item.watch_count}}次播放</div>
                            </div>
                            </el-col>
                        </el-row>
                        <el-pagination
                                background
                                layout="prev, pager, next, jumper"
                                :total="countData" :page-size="16" @current-change="getVideoList" :current-page.sync="currentPage" v-if="videoStatus == '3'">
                            </el-pagination>
                            
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </template>
    </div>
</template>

<script>
import { getVideoTags, getVideoList, getVideoUrl } from '@/api/video'
import { mapState } from "vuex"
import { ContentLoader } from 'vue-content-loader'
export default {
    components: {
        ContentLoader
    },
    data() {
        return {
            tabList: [
                { tag_name: "全部",id: '' },
            ],
            typeList: [{tag_name: "全部",id: ''}],
            activeTag: 0,
            videoList: [],
            showNoData: false,
            currentPage: 1,
            countData: 0,
            videoBg: require("../../assets/images/news1.png"),
            videoUrl: '',
            selectId: '',
            videoStatus: '1',
            typeMoreList: [],
            hoverMoreStatus: false,
        };
    },
    computed: {
        ...mapState({
            isLogin: state => state.user.isLogin,
            isVipStr: state => state.user.isVipStr,
        }),
    },
    watch: {
        // isVipStr(newVal) {
        //     if(newVal == "true") {
        //         this.linkToDetail(this.selectId);
        //     }
        // }
    },
    mounted() {
        this.getVideoTags();
    },
    methods: {
        activeTagHandler(e) {
            this.activeTag = e.index;
            if(e.index == 5) {
                this.hoverMoreStatus = !this.hoverMoreStatus;
                return
            }
            this.videoList = [];
            this.currentPage = 1;
            this.countData = 0;
            this.videoStatus = '1';
            this.getVideoList('1');
        },
        hoverMenuHandler(index) {
            if(index == 5) {
                this.hoverMoreStatus = !this.hoverMoreStatus;
            }
        },
        getVideoTags() {
            getVideoTags().then( res => {
                this.typeList = [...this.typeList,...res.data.reverse()];
                let tabList = res.data;
                if(tabList.length > 4) {
                    this.tabList = [...this.tabList,...tabList.splice(0,4)];
                    this.typeMoreList = [...tabList];
                    this.tabList.push({ tag_name: "更多",id: '' })
                } else {
                    this.tabList = [...this.tabList,...tabList];
                }
                this.activeTag = 0;
                this.getVideoList('1');
            })
        },
        getVideoList(page) {
            this.videoStatus = '1';
            let id = this.typeList[this.activeTag].id;
            getVideoList(page,id).then( res => {
                if(res.data.count == 0) {
                    this.videoStatus = '2';
                    return
                }
                this.videoStatus = '3';
                this.countData = res.data.count;
                this.videoList = [...res.data.data];
            })
        },
        linkToDetail(id) {
            this.selectId = id;
            if(!this.$store.state.user.token) {
                this.$store.commit('user/LOGINSTATUS', true);
                return
            };
            getVideoUrl(this.selectId).then( res => {
                if(res.status == 400) {
                    localStorage.setItem("isNewUser","false");
                    this.$store.commit('user/SHOWVIP', true);
                } else {
                    this.videoUrl = res.data;
                    window.open(res.data, '_blank');
                }
            })
        },
        changeTypeHandler3(id) {
            this.activeTag = id;
            this.hoverMoreStatus = false;
            this.videoList = [];
            this.currentPage = 1;
            this.countData = 0;
            this.videoStatus = '1';
            this.getVideoList('1');
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.class-box:hover {
    p {
        color: $common-color!important;
    }
    // -webkit-transform: scale(1.05);
    // -moz-transform: scale(1.05);
    // -ms-transform: scale(1.05);
    // transition:all 0.5s;
    // -webkit-transition:all 0.5s;
    // -ms-transition:all 0.5s;
}
.video-box-bg {
    background: url("../../assets/images/video-bg.jpg") no-repeat;
    background-position: center;
    background-size: cover;
    height: 132px;
}
.video-box {
    .video-box-list {
        @include gwidth;
    }
    .video-box-content {
        min-height: 350px;
        margin-top: 7px;
    }
    .type-list {
        @include gflex;
        font-size: 0;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 8px;
        border-bottom: 1px solid #f0f2f5;
        padding-bottom: 12px;
        .title-box {
            width: 78px;
            padding: 3px 6px 3px 0;
            font-size: 14px;
            text-align: left;
            color: #909399;
        }
        a {
            display: inline-block;
            font-size: 14px;
            color: #5e6166;
            cursor: pointer;
            text-align: center;
            margin-bottom: 12px;
            padding: 3px 6px;
        }
        a:not(:nth-child(13n)) {
            margin-right: 12px;
        }
        a:hover {
            color: $common-color;
        }
        .active-tag {
            color: #ffffff!important;
            background: $common-color;
            border-radius: 4px;
        }
        .type-name {
            @include gflex;
            width: calc(100% - 4px);
            justify-content: flex-start;
            flex-wrap: wrap;
        }
    }
    .video-list {
        margin-top: 0px;
        margin-bottom: 8px;
        >.el-col {
            padding-right: 16px;
            box-sizing: border-box;
        }
        .class-box {
            border-radius: 10px;
            margin-bottom: 32px;
            cursor: pointer;
        }
        .video-bg {
            width: 100%;
            height: 160px;
            background-size: cover;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            img {
                width: 54px;
                height: 54px;
                display: none;
            }
        }
        .class-box:hover {
            // -webkit-transform: scale(1.05);
            // -moz-transform: scale(1.05);
            // -ms-transform: scale(1.05);
            // transition:all 0.5s;
            // -webkit-transition:all 0.5s;
            // -ms-transition:all 0.5s;
            .video-bg {
                border-radius: 10px;
                box-shadow: 0px 4px 8px 0px rgba(56,56,56,0.3);
            }
            img {
                display: block;
            }
        }
        .video-free {
            width: 32px;
            height: 20px;
            background: #f5f1f0;
            border: 1px solid #ccc6c4;
            border-radius: 2px;
            font-size: 12px;
            font-weight: 400;
            color: #66605e;
            text-align: center;
            line-height: 20px;
            position: relative;
            top: 9px;
            left: 0px;
        }
        .video-free-vip {
            background: #fff5f0;
            border: 1px solid $common-color;
            border-radius: 2px;
            color: $common-color;
        }
        p {
            color: #2c2e33;
            font-size: 14px;
            font-weight: 400;
            margin: 12px 12px 12px 20px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;
            /*! autoprefixer: on */
        }
    }
    .video-count {
        color: #999390;
        font-size: 12px;
    }
}
.no-data-box {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
        margin-left: -14px;
    }
}
.menu-tools-ul {
    position: absolute;
    min-width: 112px;
    height: auto;
    padding: 14px 0;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 1px 6px 0px rgba(51,55,61,0.20); 
    z-index: 9999;
    color: #5e6166;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 40px;
    box-sizing: border-box;
    left: -46px;
    top: 48px;
    margin-top: -8px;
    background: rgba(255,255,255,0.80);
    border-radius: 10px;
    box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.10); 
    backdrop-filter: blur(6px);
    .menu-li {
        color: #332e2c!important;
        font-size: 18px;
        font-weight: 600;
    }
    li {
        padding: 0 24px;
        list-style: none;
        cursor: pointer;
    }
    li:hover {
        color: $common-color;
    }
}
</style>